var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "#F5F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 21.3333C14.9797 21.3333 14.6406 21.1929 14.3905 20.9428C14.1405 20.6928 14 20.3536 14 20H16.6667C16.6667 20.3536 16.5262 20.6928 16.2761 20.9428C16.0261 21.1929 15.687 21.3333 15.3333 21.3333ZM20.6667 19.3333H10V18L11.3333 17.3333V13.6667C11.3333 11.3587 12.2807 9.862 14 9.45333V8H16C15.5653 8.57596 15.3311 9.27841 15.3333 10C15.3333 10.1673 15.346 10.3347 15.3707 10.5007H15.3333C14.933 10.4747 14.5326 10.5496 14.1686 10.7183C13.8047 10.8871 13.4889 11.1444 13.25 11.4667C12.835 12.123 12.6314 12.8909 12.6667 13.6667V18H18V13.6667C18 13.526 17.9953 13.3907 17.986 13.2667C18.427 13.3577 18.8817 13.3593 19.3233 13.2713C19.3307 13.412 19.3333 13.546 19.3333 13.6713V17.3333L20.6667 18V19.3333ZM18.6667 12C18.1362 12 17.6275 11.7893 17.2525 11.4142C16.8774 11.0391 16.6667 10.5304 16.6667 10C16.6667 9.46957 16.8774 8.96086 17.2525 8.58579C17.6275 8.21071 18.1362 8 18.6667 8C19.1971 8 19.7058 8.21071 20.0809 8.58579C20.456 8.96086 20.6667 9.46957 20.6667 10C20.6667 10.5304 20.456 11.0391 20.0809 11.4142C19.7058 11.7893 19.1971 12 18.6667 12Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewNotification);
export default __webpack_public_path__ + "static/media/new_notification.fecfba52d25659effa49cef5f2e280ec.svg";
export { ForwardRef as ReactComponent };